// extracted by mini-css-extract-plugin
export default {"noFavoritesFound":"NoFavoritesFound_noFavoritesFound__qqtjh"};